import React, {Component} from 'react';
import Iconizer from "../iconizer/Iconizer";
import {Tooltip} from "reactstrap";
import {defterUnitName} from "../../helper/permission";
import {EntegratorConf} from "../../constants";

class ProgressInfoCard extends Component {

	constructor(props) {
		super(props);

		this.state = {
			tooltipOpen: {
				totalCustomer: false,
				activeCustomer: false,
				percent: false,
				totalDistributor: false,
				totalCreditSales: false,
				totalSpaceSales: false,
				lastMonthProgress: false,
				totalProgress: false
			}
		};

		this.toggle = this.toggle.bind(this);
	}

	toggle(section) {
		let state = !this.state.tooltipOpen[section];

		this.setState({
			tooltipOpen: {
				...this.state.tooltipOpen,
				[section]: state
			}
		})
	}

	tooltipMessage(tooltipId) {
		switch (tooltipId) {
			case 'totalCustomer':
				return 'Sisteme kayıtlı müşteri sayısı';
			case 'totalGIBCustomers':
				return 'GİB\'e başarıyla kaydı iletilmiş müşteri sayısı';
			case 'activeCustomer':
				return 'Son bir yıl içinde kontör alımı yapmış olan müşteri sayısı';
			case 'percent':
				return 'Aktif müşteri sayınıza göre hakediş oranı';
			case 'totalDistributor':
				return 'Alt bayilerinizin sayısı';
			case 'totalCreditSales':
				return 'Alt bayileriniz dahil toplam kontör satışı';
			case 'totalSpaceSales':
				return 'Alt bayileriniz dahil toplam '+defterUnitName(EntegratorConf.identifier)+' satışı';
			case 'lastMonthProgress':
				return 'En son faturalandırılan ayın hakediş tutarı';
			case 'totalProgress':
				return 'Toplam faturalandırılan hakediş tutarı';
		}
	}

	render() {

		return (
			<div className="progress-card">

				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '5px'}}>
					<div id={this.props.tooltipId} style={{width: '25%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
						<Iconizer name={this.props.name} height="30" width="30" fill='#2f9a46' color={this.props.color}/>
					</div>
					<Tooltip placement="bottom" isOpen={this.state.tooltipOpen[this.props.tooltipId]} target={this.props.tooltipId}
							 toggle={() => this.toggle(this.props.tooltipId)}>
						{this.tooltipMessage(this.props.tooltipId)}
					</Tooltip>

					{this.props.loading ?

						<div style={{width: '75%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
							<div className='progress-card-loading' style={{width: '30px', height: '30px'}}>
								<Iconizer name='spinner' width='30px' height='30px'/>
							</div>
						</div>

						:
						<div style={{width: '75%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
							<text className='progress-card-body-text'>
								{this.props.body}
							</text>
						</div>
					}
				</div>

				<div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: '0 5px'}}>
					<text className='progress-card-header-text'>
						{this.props.title}
					</text>
				</div>
			</div>
		)
	}
}

export default ProgressInfoCard;
